import React, { useCallback, useEffect, useState } from 'react';
import { Heading, Button, Modal, VStack, Text } from 'native-base';
import { FormControl } from 'native-base';
import { FoodRestrictions } from '../Common/FoodRestrictions';
import { InputWithLabel } from '../Form/InputWithLabel';
import { SelectWithLabel } from '../Form/SelectWithLabel';
import { useAuth } from '../../hooks';
import { Loader } from '../Loader';

export const DietHealth = () => {
  const { loading, updateUserSelf, user } = useAuth();
  const [modalVisible, setModalVisible] = useState(false);
  const initialFormData = {
    diagnosis: user?.diagnosis,
    medications: user?.medications || '',

    allergens: user?.allergen_ids ?? [],
    dietRestrictions: user?.dietary_restriction_ids ?? [],
    selectedFoods: user?.selected_food_ids ?? [],
    otherDiets: user?.other_diet_ids ?? [],
  };
  const [formData, setFormData] = useState(null);

  const save = useCallback(async () => {
    await updateUserSelf({
      diagnosis: formData.diagnosis,
      medications: formData.medications,

      allergen_ids: formData.allergens,
      dietary_restriction_ids: formData.dietRestrictions,
      selected_food_ids: formData.selectedFoods,
      other_diet_ids: formData.otherDiets,
    });
  }, [formData, updateUserSelf]);

  useEffect(() => {
    if (user?.email && !formData) {
      setFormData(initialFormData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading) return <Loader loading={loading} />;

  const InfoModal = () => {
    return (
      <Modal
        isOpen={modalVisible}
        onClose={setModalVisible}
        size={'lg'}
        _backdrop={{
          bg: 'black',
          opacity: '.75',
        }}
      >
        <Modal.Content maxH="600">
          <Modal.CloseButton />
          <Modal.Header>
            <Heading w={'80%'} fontSize={'xl'}>
              How do I change this?
            </Heading>
          </Modal.Header>
          <Modal.Body>
            <Text fontSize={'md'} fontWeight={'normal'}>
              Due to healthcare regulations, your primary residence must be in a
              participating state for you to use Ayble. Please contact us to
              change your state.
            </Text>
            <Button
              w={'100%'}
              mt={5}
              onPress={() => {
                setModalVisible(false);
              }}
            >
              Got It!
            </Button>
          </Modal.Body>
        </Modal.Content>
      </Modal>
    );
  };

  return (
    formData && (
      <>
        <VStack w={'100%'} mt={4}>
          <Heading color="black" size="md" textAlign="left">
            Health Information
          </Heading>
          <FormControl>
            <SelectWithLabel
              isDisabled={true}
              label="Condition"
              options={[]}
              value={{ label: formData.diagnosis, value: formData.diagnosis }}
            />
            <InputWithLabel
              label="Medications"
              onChange={(medications) => {
                setFormData({ ...formData, medications });
              }}
              value={formData.medications}
            />
            <Text mt={2}>
              Add all medications you take for symptoms, prevention, and pain.
            </Text>
          </FormControl>
          <Heading color="black" mt={6} mb={6} size="md" textAlign="left">
            Food Restrictions
          </Heading>
          <VStack w={'50%'} display="block">
            <FoodRestrictions
              allergies={formData.allergens}
              restrictions={formData.dietRestrictions}
              avoided={formData.selectedFoods}
              other={formData.otherDiets}
              onChange={({ allergies, restrictions, avoided, other }) =>
                setFormData({
                  ...formData,
                  allergens: allergies,
                  dietRestrictions: restrictions,
                  selectedFoods: avoided,
                  otherDiets: other,
                })
              }
              user={user}
              variant="settings"
            />
          </VStack>
          <Button mt={8} onPress={save} size="sm" type="button" w={'128px'}>
            Save
          </Button>
        </VStack>
        <InfoModal />
      </>
    )
  );
};
